<template>
  <div ref="decade"
       class="timeline__decade"
       @mousedown="onMouseDown"
       @mousemove="onMouseOver"
       @mouseup="onMouseUp"
  >
    <timeline-decade-scale :disabled-years-count="disabledYearsCount"/>

    <div class="timeline__decade__disabling-overlay"
         :style="`height: ${ disabledYearsCount * 10 }%`"
         @click.stop
         @mousedown.stop
         @mousemove.stop
    />

    <p class="timeline__decade__start-year">
      {{ startYear }}
    </p>

    <span v-for="(count, year) in imagesYears"
          :key="year"
          class="timeline__decade__image-year"
          :style="{
            bottom: `calc(${ (endYear - Math.floor(year)) * 10 }% - 2px)`
          }"
    >
      <span v-for="n in Math.min(5, count)"
            :key="n"
            class="timeline__decade__image-year__dot"
      />
      <span v-if="count > 5"
            class="timeline__decade__image-year__count"
      >
        +{{ count - 5 }}
      </span>
    </span>
  </div>
</template>

<script>
import TimelineDecadeScale from "@/components/common/TheTimeline/TimelineDecadeScale";
import { mapGetters } from "vuex";

const MAX_DOTES_COUNT = 5

export default {
  name: "TimelineDecade",
  components: {
    TimelineDecadeScale
  },
  props: {
    decade: {
      type: Object,
      required: true
    },
    isMouseDown: {
      type: Boolean,
      default: false
    },
    beforeYearFilter: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      MAX_DOTES_COUNT,
      mouseDownYear: null
    }
  },
  computed: {
    ...mapGetters('Coordinates', ['getPeriodImagesYears', 'minImageYear']),

    beforeYear: {
      get() {
        return this.beforeYearFilter
      },
      set(year) {
        if (year !== null && year < this.minImageYear) return false;
        this.$emit('update:before-year-filter', year)
      }
    },

    startYear() {
      return this.decade.startYear
    },
    endYear() {
      return this.decade.endYear
    },
    imagesYearsAll() {
      return this.getPeriodImagesYears(this.startYear, this.endYear)
    },
    imagesYears() {
      let result = {}

      this.imagesYearsAll.forEach((year) => {
        if (result[year]) {
          result[year]++
        } else {
          result[year] = 1
        }
      })

      return result
    },
    disabledYearsCount() {
      if (this.startYear >= this.minImageYear) {
        return 0
      } else if (this.endYear < this.minImageYear) {
        return 10
      } else {
        return this.minImageYear - this.startYear
      }
    }
  },
  methods: {
    onMouseDown(event) {
      let year = this.getYearFromEvent(event)
      this.beforeYear = year

      if (year === this.beforeYear) {
        this.mouseDownYear = year
      } else {
        this.mouseDownYear = null
      }
    },
    onMouseOver(event) {
      if (this.isMouseDown) {
        this.beforeYear = this.getYearFromEvent(event)
      }
    },
    onMouseUp(event) {
      let year = this.getYearFromEvent(event)

      if (year === this.mouseDownYear) {
        this.beforeYear = null
      }
    },
    getYearFromEvent(event) {
      return this.startYear + Math.abs(Math.round((event.offsetY / this.$refs['decade'].offsetHeight) * 10))
    }
  }
}
</script>

<style lang="scss">
.timeline__decade {
  position: relative;
  padding-top: 4px;
  height: 108px;

  &__scale {
    cursor: pointer;
  }

  &__disabling-overlay {
    position: absolute;
    top: 0;
    left: 50%;
    width: 24px;
    transform: translateX(-50%);
  }

  &__start-year {
    position: absolute;
    right: 30px;
    font-size: 1.3em;
    top: 4px;
    transform: translateY(-50%);
  }

  &__image-year {
    position: absolute;
    left: 30px;
    display: flex;
    color: $app-primary-color;
    font-size: .7em;
    transform: translateY(-5px);

    &__dot {
      display: block;
      width: 7px;
      height: 7px;
      background-color: $app-primary-color;
      border-radius: 50%;
      margin-right: 1px;
    }

    &__count {
      line-height: 7px;
      margin-left: 3px;
    }

  }

}

@include smallerThan("xl") {
  .timeline__decade {
    font-size: .8em;
    line-height: 1.5em;
  }
}
</style>